import Vue from 'vue'

const state = {
    ftoAccounts: {
        miningAccount            : null,
        miningOriginalAccount    : null,
        royalBonusAccount        : null,
        allowToWithdrawFromRoyal : null
    }
};

const getters = {
    ftoAccounts: state => {
        return state.ftoAccounts
    }
};

const mutations = {
    setFtoAccounts (state, data) {
        Vue.set(state, 'ftoAccounts', {
            miningAccount               : data.mining_account.amount,
            miningOriginalAccount       : data.mining_original_account.amount,
            royalBonusAccount           : data.royal_bonus_account.amount,
            royalBonusOriginalAccount   : data.royal_bonus_original_account.amount,
            allowToWithdrawFromRoyal    : data.allow_to_withdraw_from_royal.amount
        });
    }
};

export default {
    state,
    getters,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/ftoAccounts.js